import clsx from 'clsx';
import {createElement} from 'react';

import type {ThemeColourGroups} from '../../theme';
import type {tags} from '../Text/tags';

const colourVariants = {
  slate: 'bg-slate3 ring-slate7 text-slate11',
  blue: 'bg-blue3 ring-blue7 text-blue11',
  tomato: 'bg-tomato3 ring-tomato7 text-tomato11',
  grass: 'bg-grass3 ring-grass7 text-grass11',
  amber: 'bg-amber3 ring-amber7 text-amber11',
};
const hoverColourVariants = {
  slate: 'hover:bg-slate3 hover:ring-slate7 hover:text-slate11',
  blue: 'hover:bg-blue3 hover:ring-blue7 hover:text-blue11',
  tomato: 'hover:bg-tomato3 hover:ring-tomato7 hover:text-tomato11',
  grass: 'hover:bg-grass3 hover:ring-grass7 hover:text-grass11',
  amber: 'hover:bg-amber3 hover:ring-amber7 hover:text-amber11',
};

type Props = React.HTMLAttributes<HTMLElement> & {
  colour: ThemeColourGroups;
  hoverColour?: ThemeColourGroups;
  element?: (typeof tags)[number];
  children: React.ReactNode;
};
export function Badge({
  element = 'span',
  colour,
  hoverColour,
  className,
  children,
  ...props
}: Props): React.JSX.Element {
  const cn = clsx(
    className,
    'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
    colourVariants[colour],
    hoverColour ? hoverColourVariants[hoverColour] : null,
    hoverColour && 'cursor-pointer'
  );

  return createElement(element, {...props, className: cn}, children);
}

// function getBadgeColourProperties(c: ThemeColourGroups): string {
//   return `bg-${c}3 ring-${c}7 text-${c}11`;
// }
// function getBadgeHoverColourProperties(c: ThemeColourGroups): string {
//   return `hover:bg-${c}3 hover:ring-${c}7 hover:text-${c}11`;
// }

Badge.displayName = 'Badge';
